import { gql } from "@apollo/client";
import { TOPIC_BASIC_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_TEACHER_CLASSES = gql`
  query GetTeacherClasses(
    $teacherId: ID!
    $levelId: ID
    $first: Int
    $after: String
  ) {
    teacherClasses(
      teacherId: $teacherId
      levelId: $levelId
      first: $first
      after: $after
    ) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        date
        time
        classType
        classSize
        category
        seatsRemaining
        bookedAt
        overlapped
        credits
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          ...TopicBasicFields
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
      }
    }
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;

export default GET_TEACHER_CLASSES;
